import { render, staticRenderFns } from "./DialogShopOpenHours.vue?vue&type=template&id=1a693221&lang=html"
import script from "./DialogShopOpenHours.vue?vue&type=script&lang=js"
export * from "./DialogShopOpenHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports